import { render, staticRenderFns } from "./BasicPointRuleList.vue?vue&type=template&id=0a064c03&"
import script from "./BasicPointRuleList.vue?vue&type=script&lang=js&"
export * from "./BasicPointRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports